// src/services/auth.js

// Constantes pour le stockage local
const SESSION_ID_KEY = 'decko_session';
const USER_DATA_KEY = 'decko_user';

// Configuration de l'URL de base pour l'API PHP
const API_BASE_URL = 'https://decko.fr/api';

export const authService = {
    // Connexion
    login: async (username, password) => {
        try {
            console.log("Tentative de connexion avec:", { username, password }); // Debug

            const response = await fetch(`${API_BASE_URL}/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
                credentials: 'include'
            });

            console.log("Réponse reçue:", response); // Debug

            if (!response.ok) {
                const errorText = await response.text();
                let errorMessage;
                try {
                    const errorData = JSON.parse(errorText);
                    errorMessage = errorData.error || `Erreur ${response.status}`;
                } catch {
                    errorMessage = `Erreur ${response.status}: ${response.statusText}`;
                }
                throw new Error(errorMessage);
            }

            const data = await response.json();
            console.log("Données de réponse:", data); // Debug

            // Check if data has the expected structure
            if (data && data.success) {
                localStorage.setItem(USER_DATA_KEY, JSON.stringify(data.user));
                localStorage.setItem(SESSION_ID_KEY, data.session_id);
                return data.user;
            } else {
                throw new Error("Réponse de connexion invalide");
            }
        } catch (error) {
            console.error("Erreur de connexion:", error);
            throw error;
        }
    },

    // Déconnexion simplifiée (local seulement)
    logout: () => {
        console.log("Déconnexion de l'utilisateur..."); // Debug
        localStorage.removeItem(SESSION_ID_KEY);
        localStorage.removeItem(USER_DATA_KEY);
        console.log("Utilisateur déconnecté."); // Debug
    },

    // Récupérer l'utilisateur actuellement connecté
    getCurrentUser: () => {
        const userData = localStorage.getItem(USER_DATA_KEY);
        console.log("Données utilisateur récupérées:", userData); // Debug
        return userData ? JSON.parse(userData) : null;
    },

    // Vérifier si l'utilisateur est connecté (local seulement)
    isLoggedIn: () => {
        const isLoggedIn = !!localStorage.getItem(SESSION_ID_KEY);
        console.log("Utilisateur connecté:", isLoggedIn); // Debug
        return isLoggedIn;
    },

    // Vérification simplifiée (toujours valide si session existe)
    verifySession: async () => {
        const sessionValid = !!localStorage.getItem(SESSION_ID_KEY);
        console.log("Session valide:", sessionValid); // Debug
        return sessionValid;
    }
};

export default authService;
